import { Navigate } from 'react-router-dom';

import { FOOTBALL_PLAY_PRO } from '@sorare/core/src/constants/__generated__/routes';

const LeaderboardPage = () => {
  return <Navigate to={FOOTBALL_PLAY_PRO} />;
};

export default LeaderboardPage;
